exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fileAttachmentDrawer .ant-drawer-header {\n  padding: 0;\n  padding-bottom: 0.5rem;\n}\n.fileAttachmentDrawer .ant-drawer-right .ant-drawer-content-wrapper {\n  width: 50% !important;\n}\n.fileAttachmentDrawer__list {\n  background-color: #f5f5f5;\n  margin: 1rem;\n  padding: 0.5rem;\n}\n.fileAttachmentDrawer__download-all {\n  position: relative;\n  right: -7rem;\n  top: 0.35rem;\n  font-size: 1.2rem;\n  z-index: 1;\n}\n.fileAttachment__empty {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports
